import DOMPurify from "dompurify";
import { titleCase } from "./functions";

const TRANSFORMS = {
  titleCase,
};

const escapeHtml = (value) =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

export const interpolate = (str, ctx) => {
  if (typeof str !== "string") return str;
  return str.replace(/{{\s*(\w+)(?:\s*\|\s*(\w+))?\s*}}/g, (_, key, transform) => {
    const raw = ctx?.[key] !== undefined && ctx?.[key] !== null ? ctx[key] : "";
    const fn = transform && TRANSFORMS[transform];
    return escapeHtml(fn ? fn(raw) : raw);
  });
};

export const renderTemplateHtml = (rawHtml, ctx) => {
  const sanitizedTemplate = DOMPurify.sanitize(rawHtml);
  const interpolated = interpolate(sanitizedTemplate, ctx);
  return DOMPurify.sanitize(interpolated);
};
